var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBrunei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 31.9978C24.8358 31.9978 31.9982 24.8354 31.9982 16.0001C31.9982 7.16484 24.8358 0.00244141 16.0006 0.00244141C7.16532 0.00244141 0.00292969 7.16484 0.00292969 16.0001C0.00292969 24.8354 7.16532 31.9978 16.0006 31.9978Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14567 8.00122C1.42359 9.25175 0.890958 10.5591 0.536263 11.8909L27.2905 27.3375C28.2664 26.3644 29.1324 25.2493 29.8543 23.9989L2.14567 8.00122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 2.14561C17.598 -1.55004 9.70536 -0.318322 4.70982 4.66253L31.464 20.1091C33.2799 13.2925 30.4002 5.84131 23.9992 2.14561Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00124 29.8544C14.4022 33.5501 22.2951 32.3184 27.2905 27.3376L0.536263 11.8909C-1.27946 18.7076 1.6001 26.1588 8.00124 29.8544Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5211 14.2613C20.5211 16.7581 18.497 18.7824 16 18.7824C13.5031 18.7824 11.4789 16.7582 11.4789 14.2613C11.4789 13.4828 11.6757 12.7502 12.0224 12.1106C11.0413 13.1139 10.4356 14.486 10.4356 16.0001C10.4356 19.0732 12.9268 21.5645 16 21.5645C19.0732 21.5645 21.5645 19.0733 21.5645 16.0001C21.5645 14.486 20.9588 13.1139 19.9777 12.1106C20.3243 12.7503 20.5211 13.4828 20.5211 14.2613Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9568 9.04468H17.0435V19.478H14.9568V9.04468Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4778 11.1313H12.5223C12.5223 11.6115 12.9407 12.0008 13.4208 12.0008H13.3918C13.3918 12.481 13.7811 12.8703 14.2612 12.8703C14.2612 13.3505 14.6506 13.7397 15.1307 13.7397H16.8696C17.3497 13.7397 17.739 13.3505 17.739 12.8703C18.2192 12.8703 18.6085 12.481 18.6085 12.0008H18.5795C19.0595 12.0007 19.4778 11.6116 19.4778 11.1313Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1308 20.1736H20.8685V22.2603H11.1308V20.1736Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0868 20.8691H22.26V22.9558H18.0868V20.8691Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74021 20.8691H13.9135V22.9558H9.74021V20.8691Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBrunei);
export default __webpack_public_path__ + "static/media/flag_brunei.81dfab6be6b5e568a9d2ea7908e783f9.svg";
export { ForwardRef as ReactComponent };